import { render, staticRenderFns } from "./OperacionesEditComentarios.vue?vue&type=template&id=11c1c3b8&"
import script from "./OperacionesEditComentarios.vue?vue&type=script&lang=js&"
export * from "./OperacionesEditComentarios.vue?vue&type=script&lang=js&"
import style0 from "./OperacionesEditComentarios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports